import { privateApi } from '../../api';
import { responseToast } from '../components/Toast';
import createService from '../store/serverState';
import { Getter, Setter } from '../store/store.types';
import { IBannersResponse, IUpdateBannersResponse, MediaPayload } from './types/banners';

const getBanners = async () => {
  const { data } = await privateApi.get<IBannersResponse>('/banners');
  return data;
};

const updateBanner = async ({ id, media }: { id: string; media: MediaPayload }) => {
  const { data } = await privateApi.patch<IUpdateBannersResponse>(`/banners/${id}`, media);
  responseToast({ title: 'Imagem salva com sucesso!', status: 'success' });
  return data;
};

const deleteBanner = async (id: string) => {
  const { data } = await privateApi.delete<IUpdateBannersResponse>(`/banners/${id}`);
  responseToast({ title: 'Imagem do banner deletada com sucesso!', status: 'success' });
  return data;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const createBannersEndPoints = (set: Setter, get: Getter) => {
  const createEndpoint = createService({
    set,
    getSlice: ({ banners }) => banners,
    prefix: 'banners',
  });

  return {
    fetchBanners: createEndpoint('fetchBanners', getBanners, {
      placeholder: {
        status: '',
        data: { banners: [] },
      },
    }),
    saveBanner: createEndpoint('saveBanner', updateBanner, {
      placeholder: {
        status: '',
        data: {
          updatedBanner: {
            id: '',
            name: '',
            media: {
              analyticsId: '',
              imageUrl: '',
              mediaId: '',
              url: '',
            },
            createdAt: '',
            updatedAt: '',
          },
        },
      },
      shouldThrowError: true,
    }),
    deleteBanner: createEndpoint('deleteBanner', deleteBanner, {
      placeholder: { status: '', data: {} },
    }),
  };
};

export default {
  getBanners,
  updateBanner,
  deleteBanner,
};
